export type RBACType =
  | 'device'
  | 'device.ssh'
  | 'ai.ssh'
  | 'credentials'
  | 'runbooks'
  | 'rbac.role'
  | 'rbux.scope'
  | 'connectivity_costs'
  | 'custom_nms_reports'
  | 'credential_vault'
  | 'dashboards'
  | 'board'
  | 'saved_views'
  | 'synthetics.agent'
  | 'synthetics.test'
  | 'rbac.role.users'
  | 'rbac.permission'
  | 'tenant'
  | 'package'
  | 'alerting.policies'
  | 'alerting.notifications'
  | 'alerting.silences'
  | 'alerting.suppressions'
  | 'alerting.autoacks'
  | 'protect.mitigations'
  | 'protect.announcements'
  | 'ai.mcp_servers'
  | 'asset_tag';

export type RBACAction = 'create' | 'read' | 'update' | 'delete';

export type RBACString =
  | `${RBACType}::${RBACAction}`
  | 'rbac.role.user::assign_to_role'
  | 'rbac.role.user::remove_from_role'
  | 'rbux.scope.user::assign_to_scope'
  | 'rbux.scope.user::remove_from_scope'
  | 'alerting.alerts::read'
  | 'alerting.alerts::clear'
  | 'alerting.alerts::ack'
  | 'alerting.alerts::debug'
  | 'alerting.policies::debug'
  | 'protect.mitigations::start'
  | 'protect.mitigations::stop'
  | 'protect.mitigations::manual'
  | 'protect.announcements::read'
  | 'protect.announcements::withdraw'
  | 'device.command::execute'
  | 'device.config::read';

export const RBAC_DEVICE_COMMAND_EXECUTE = 'device.command::execute' satisfies RBACString;
export const RBAC_DEVICE_CONFIG_READ = 'device.config::read' satisfies RBACString;

export const RBAC_SAVED_VIEWS_READ = 'saved_views::read' satisfies RBACString;
export const RBAC_SYNTHETICS_TEST_READ = 'synthetics.test::read' satisfies RBACString;
export const RBAC_SYNTHETICS_AGENT_READ = 'synthetics.agent::read' satisfies RBACString;

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACDevicePermission {
  CREATE = 'device::create',
  READ = 'device::read',
  UPDATE = 'device::update',
  DELETE = 'device::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACCustomNmsReportPermission {
  CREATE = 'custom_nms_reports::create',
  READ = 'custom_nms_reports::read',
  UPDATE = 'custom_nms_reports::update',
  DELETE = 'custom_nms_reports::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACDashboardPermission {
  CREATE = 'dashboards::create',
  READ = 'dashboards::read',
  UPDATE = 'dashboards::update',
  DELETE = 'dashboards::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACBoardPermission {
  CREATE = 'board::create',
  READ = 'board::read',
  UPDATE = 'board::update',
  DELETE = 'board::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACSavedViewPermission {
  CREATE = 'saved_views::create',
  READ = 'saved_views::read',
  UPDATE = 'saved_views::update',
  DELETE = 'saved_views::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBACRunbookPermission {
  CREATE = 'runbooks::create',
  READ = 'runbooks::read',
  UPDATE = 'runbooks::update',
  DELETE = 'runbooks::delete'
}

/** For existing *.js permission check. *ts should use RBACString type */
export enum RBUXScopePermission {
  CREATE = 'rbux.scope::create',
  READ = 'rbux.scope::read',
  UPDATE = 'rbux.scope::update',
  DELETE = 'rbux.scope::delete',
  ASSIGN_TO_USER = 'rbux.scope.user::assign_to_scope',
  REMOVE_FROM_USER = 'rbux.scope.user::remove_from_scope'
}

export enum RBACAssetTagPermission {
  CREATE = 'asset_tag::create',
  READ = 'asset_tag::read',
  UPDATE = 'asset_tag::update',
  DELETE = 'asset_tag::delete'
}

/**
 * TODO WARNING: Unfortunately you can't add any more roles to this collection as the backend does not support this!
 * TODO You will first need to verify that fetchPermittedLabelItems has been updated to allow for multi-permission fetches.
 * TODO then remove these TODOs so nobody else worries about it :)
 */
export const NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS: RBACString[] = ['device::read'];
